import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { DataProvider } from "../../data-provider/data-provider";
import { SocketService } from "../../env-set-up/socket";
import { Campaign } from "../../models/campaign.model";
import { Division } from "../../models/division.model";
import { Organisation } from "../../models/organisation.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { WhiteLabelDataProvider } from "../../data-provider/white-label.dp";
import { DivisionDataProvider } from "../../data-provider/division.dp";
import { ToastUtils } from "../../helper/toast.helper";

let DivisionSwitchComponent = {
    selector: "vcDivisionSwitch",
    templateUrl: "/angular/components/division/division-switch.component.html",
    bindings: {
        divisionUsers: "=?",
    },
    controller: class DivisionSwitchController {
        // * bindings for typescript compiler *
        public divisionUsers?: any;
        // ************************************

        private readonly $scope: any;
        private readonly $window: any;
        public readonly __env: any;
        private globalDataProvider: DataProvider;
        public navigationBarService: NavigationBarHelperService;
        public campaignDataProvider: CampaignDataProvider;
        public effortDataProvider: EffortDataProvider;
        public permissionProvider: PermissionCheck;
        public dataProvider: DivisionDataProvider;
        public socketService: SocketService;
        public loading: boolean = true;

        public activeCampaign: Campaign;
        public activeOrganisation: Organisation;
        public divisions: Array<Division> | null;
        public isLeaderView: boolean;
        public showCampaigns: boolean = false;
        public searchString: string = "";
        public whiteLabelDataProvider: WhiteLabelDataProvider;
        private toast: ToastUtils;

        constructor(
            $scope: any,
            CampaignDataProvider: CampaignDataProvider,
            DivisionDataProvider: DivisionDataProvider,
            __app_type: any,
            $window: any,
            SocketService: any,
            __env: any,
            DataProvider: DataProvider,
            PermissionCheck: PermissionCheck,
            EffortDataProvider: EffortDataProvider,
            WhiteLabelDataProvider: WhiteLabelDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.globalDataProvider = DataProvider;
            this.effortDataProvider = EffortDataProvider;
            this.permissionProvider = PermissionCheck;
            this.socketService = SocketService;
            this.whiteLabelDataProvider = WhiteLabelDataProvider;
            this.navigationBarService = NavigationBarHelperService;
            this.toast = ToastUtils;
            this.$window = $window;
            this.campaignDataProvider = CampaignDataProvider;
            this.dataProvider = DivisionDataProvider;
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.isLeaderView = __app_type == "LEADER";
        }

        $onInit() {
            this.$scope.$watch(
                () => this.activeCampaign,
                (newValue: any, oldValue: any) => {
                    if (newValue && newValue.oid !== oldValue.oid) {
                        this.getOrganisations();
                        this.divisions = null;
                        this.campaignDataProvider.clearOrganisations();
                        this.dataProvider.clearAll();
                    }
                },
                true
            );

            this.getOrganisations();
        }

        getOrganisations(): void {
            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.activeOrganisation = organisation;
                    if (parseInt(this.activeOrganisation.permissionid) > 7) {
                        this.dataProvider
                            .getAllDivisions()
                            .then((divisions: Array<Division>) => {
                                this.divisions = divisions;
                            });
                    }
                });
        }

        changeLiveCampaign(campaign: Campaign): void {
            this.showCampaigns = false;
            angular.forEach(this.divisions, (division: Division) => {
                division.showCampaigns = false;
            });

            this.campaignDataProvider.campaignSwitching = true;
            this.campaignDataProvider
                .changeLiveCampaign(campaign)
                .then(
                    (campaign: Campaign) => {
                        this.initNewCampaignData(campaign);
                        if (
                            this.$window.location.pathname.includes(
                                "/leader.php"
                            )
                        ) {
                            this.$window.location = "/#/";
                        }

                        setTimeout(() => {
                            this.$window.location.reload();

                            setTimeout(() => {
                                this.campaignDataProvider.campaignSwitching = false;
                            }, 200);
                        }, 200);
                    },
                    (error: any) => {
                        this.campaignDataProvider.campaignSwitching = false;
                        this.toast.error(error);
                    }
                );
        }

        initNewCampaignData(campaign): void {
            this.activeCampaign = campaign;
            this.socketService.changeTopic(campaign.campaignid, "campaign");
            this.globalDataProvider.clearAll();
            this.permissionProvider.setPermission(campaign.permissionid);
            this.effortDataProvider.getAllEfforts();
        }

        logoClicked(): void {
            if (!this.navigationBarService.menuItemsHidden) {
                if (parseInt(this.activeOrganisation.permissionid) > 7) {
                    this.showCampaigns = !this.showCampaigns;
                } else {
                    this.$window.location = "/#/";
                }
            }
        }
    },
};

angular
    .module("division")
    .component(DivisionSwitchComponent.selector, DivisionSwitchComponent);
